import { render } from "./index.vue?vue&type=template&id=007ed227&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=007ed227&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/hub_thunnus/hub_thunnus/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-007ed227"],['__file',"src/views/order/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "007ed227"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('007ed227', __exports__)) {
    console.log('reload')
    api.reload('007ed227', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=007ed227&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('007ed227', render)
  })

}


export default __exports__